import { usePlayer } from "../../player/context.js";
import { renderElement } from "../../utils/use-render.js";
import { useSliderContext, useSliderPointerValue } from "../slider/context.js";
import { TimeSliderChaptersCore } from "@videojs/core";
import { selectTextTrack, selectTime } from "@videojs/core/dom";
import { forwardRef, useMemo, useState } from "react";
//#region src/ui/time-slider/chapter-title.tsx
/** Displays the chapter title at the current pointer or keyboard position. */
const TimeSliderChapterTitle = forwardRef(function TimeSliderChapterTitle(componentProps, ref) {
	const { render, className, style, ...elementProps } = componentProps;
	const slider = useSliderContext();
	const pointerValue = useSliderPointerValue();
	const textTrack = usePlayer(selectTextTrack);
	const time = usePlayer(selectTime);
	const [core] = useState(() => new TimeSliderChaptersCore());
	const { chapters } = useMemo(() => core.getRanges(textTrack?.chaptersCues ?? [], 0, time?.duration ?? 0), [
		core,
		textTrack?.chaptersCues,
		time?.duration
	]);
	const keyboard = slider.state.interactive && !slider.state.pointing && !slider.state.dragging;
	const value = slider.state.pointing || slider.state.dragging ? pointerValue : slider.state.value;
	const cue = core.findChapter(chapters, value)?.cue ?? null;
	const state = {
		cue,
		text: cue?.text ?? ""
	};
	return renderElement("span", {
		render,
		className,
		style
	}, {
		state,
		ref,
		props: [{
			"aria-hidden": keyboard ? void 0 : true,
			"aria-live": keyboard ? "polite" : void 0,
			children: state.text
		}, elementProps]
	});
});
//#endregion
export { TimeSliderChapterTitle };

//# sourceMappingURL=chapter-title.js.map